import { render, staticRenderFns } from "./general-journal-record.vue?vue&type=template&id=69f66e9c"
import script from "./general-journal-record.vue?vue&type=script&lang=js"
export * from "./general-journal-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports